var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 7,
    fill: "#FAE4E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75098 10.4792C7.75098 10.3289 7.87285 10.207 8.02319 10.207H31.9778C32.1281 10.207 32.25 10.3289 32.25 10.4792V31.9839C32.25 32.1343 32.1281 32.2562 31.9778 32.2562H8.02319C7.87285 32.2562 7.75098 32.1343 7.75098 31.9839L7.75098 10.4792ZM10.9054 13.3415C10.7551 13.3415 10.6332 13.4633 10.6332 13.6137V28.8495C10.6332 28.9999 10.7551 29.1217 10.9054 29.1217H29.0955C29.2459 29.1217 29.3678 28.9999 29.3678 28.8495V13.6137C29.3678 13.4633 29.2459 13.3415 29.0955 13.3415H10.9054Z",
    fill: "#E43A04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2012 17.2031L8.80206 17.2031L8.80206 11.6033L31.2012 11.6033L31.2012 17.2031Z",
    fill: "#E43A04"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3262 6.00586L28.3262 13.0056L25.0596 13.0056L25.0596 6.00586L28.3262 6.00586Z",
    fill: "#E43A04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1035 6.00586L15.1035 13.0056L11.837 13.0056L11.837 6.00586L15.1035 6.00586Z",
    fill: "#E43A04"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3262 6.00586L28.3262 9.50572L25.0596 9.50572L25.0596 6.00586L28.3262 6.00586Z",
    fill: "#E43A04"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1035 6.00586L15.1035 9.50572L11.837 9.50572L11.837 6.00586L15.1035 6.00586Z",
    fill: "#E43A04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCalendarIcon);
export default __webpack_public_path__ + "static/media/info-calendar-icon.53f28ce95cc8d8a56e66f71b087c1bb4.svg";
export { ForwardRef as ReactComponent };